import { prop, ComponentEventBus, inject } from "fw";

let uniqueId = 0;

export interface IDropdownFieldOptions {
    value: unknown;
    text: string;
}

@inject
export class DropdownField {
    constructor(private ceb: ComponentEventBus) {}

    @prop(null) label: string;
    @prop("Choose an option") ariaLabel: string;
    @prop(null) value: unknown;
    @prop(false) disabled: boolean;
    @prop(null) validation: string;
    @prop(() => []) options: IDropdownFieldOptions[];

    private uniqueId = uniqueId++;

    get id() {
        return `${this.label ? this.label.replace(/\s/g, "") : ""}-sf-${this.uniqueId}`;
    }

    get pValue() {
        return this.value;
    }

    set pValue(v: unknown) {
        this.ceb.updateModel(v);
        this.ceb.dispatch("update:value", v);
    }
}
